export var currencyCatalog = [{
  id: 'AED',
  name: 'د.إ'
}, {
  id: 'AFN',
  name: '؋'
}, {
  id: 'ALL',
  name: 'L'
}, {
  id: 'AMD',
  name: '֏'
}, {
  id: 'ANG',
  name: 'ƒ'
}, {
  id: 'AOA',
  name: 'Kz'
}, {
  id: 'ARS',
  name: '$'
}, {
  id: 'AUD',
  name: 'A$'
}, {
  id: 'AWG',
  name: 'ƒ'
}, {
  id: 'AZN',
  name: '₼'
}, {
  id: 'BAM',
  name: 'КМ'
}, {
  id: 'BBD',
  name: '$'
}, {
  id: 'BDT',
  name: '৳'
}, {
  id: 'BHD',
  name: 'د.ب'
}, {
  id: 'BIF',
  name: 'Fr'
}, {
  id: 'BMD',
  name: '$'
}, {
  id: 'BND',
  name: '$'
}, {
  id: 'BOB',
  name: 'Bs.'
}, {
  id: 'BRL',
  name: 'R$'
}, {
  id: 'BSD',
  name: '$'
}, {
  id: 'BTN',
  name: 'Nu.'
}, {
  id: 'BWP',
  name: 'P'
}, {
  id: 'BYN',
  name: 'Br'
}, {
  id: 'BZD',
  name: '$'
}, {
  id: 'CAD',
  name: 'CA$'
}, {
  id: 'CDF',
  name: 'Fr'
}, {
  id: 'CHF',
  name: 'CHF'
}, {
  id: 'CLP',
  name: '$'
}, {
  id: 'CNH',
  name: '¥'
}, {
  id: 'CNY',
  name: 'CN¥'
}, {
  id: 'COP',
  name: '$'
}, {
  id: 'CRC',
  name: '₡'
}, {
  id: 'CUP',
  name: '$'
}, {
  id: 'CVE',
  name: '$'
}, {
  id: 'CZK',
  name: 'Kč'
}, {
  id: 'DJF',
  name: 'Fdj'
}, {
  id: 'DKK',
  name: 'kr.'
}, {
  id: 'DOP',
  name: '$'
}, {
  id: 'DZD',
  name: 'د.ج'
}, {
  id: 'EGP',
  name: 'ج.م'
}, {
  id: 'ERN',
  name: 'Nfk'
}, {
  id: 'ETB',
  name: 'Br'
}, {
  id: 'EUR',
  name: '€'
}, {
  id: 'FJD',
  name: '$'
}, {
  id: 'FKP',
  name: '£'
}, {
  id: 'GBP',
  name: '£'
}, {
  id: 'GEL',
  name: '₾'
}, {
  id: 'GGP',
  name: '£'
}, {
  id: 'GHS',
  name: '₵'
}, {
  id: 'GIP',
  name: '£'
}, {
  id: 'GMD',
  name: 'D'
}, {
  id: 'GNF',
  name: 'Fr'
}, {
  id: 'GTQ',
  name: 'Q'
}, {
  id: 'GYD',
  name: '$'
}, {
  id: 'HKD',
  name: 'HK$'
}, {
  id: 'HNL',
  name: 'L'
}, {
  id: 'HTG',
  name: 'G'
}, {
  id: 'HUF',
  name: 'Ft'
}, {
  id: 'IDR',
  name: 'Rp'
}, {
  id: 'ILS',
  name: '₪'
}, {
  id: 'IMP',
  name: '£'
}, {
  id: 'INR',
  name: '₹'
}, {
  id: 'IQD',
  name: 'ع.د'
}, {
  id: 'IRR',
  name: '﷼'
}, {
  id: 'ISK',
  name: 'kr.'
}, {
  id: 'JEP',
  name: '£'
}, {
  id: 'JMD',
  name: '$'
}, {
  id: 'JOD',
  name: 'د.ا'
}, {
  id: 'JPY',
  name: '¥'
}, {
  id: 'KES',
  name: 'KSh'
}, {
  id: 'KGS',
  name: 'som'
}, {
  id: 'KHR',
  name: '៛'
}, {
  id: 'KMF',
  name: 'Fr'
}, {
  id: 'KPW',
  name: '₩'
}, {
  id: 'KRW',
  name: '₩'
}, {
  id: 'KWD',
  name: 'د.ك'
}, {
  id: 'KYD',
  name: '$'
}, {
  id: 'KZT',
  name: '₸'
}, {
  id: 'LAK',
  name: '₭'
}, {
  id: 'LBP',
  name: 'ل.ل'
}, {
  id: 'LKR',
  name: '₨'
}, {
  id: 'LRD',
  name: '$'
}, {
  id: 'LSL',
  name: 'L'
}, {
  id: 'LYD',
  name: 'ل.د'
}, {
  id: 'MAD',
  name: 'د.م.'
}, {
  id: 'MDL',
  name: 'L'
}, {
  id: 'MGA',
  name: 'Ar'
}, {
  id: 'MKD',
  name: 'ден'
}, {
  id: 'MMK',
  name: 'K'
}, {
  id: 'MNT',
  name: '₮'
}, {
  id: 'MOP',
  name: 'P'
}, {
  id: 'MRO',
  name: 'UM'
}, {
  id: 'MRU',
  name: 'UM'
}, {
  id: 'MUR',
  name: '₨'
}, {
  id: 'MVR',
  name: 'Rf'
}, {
  id: 'MWK',
  name: 'MK'
}, {
  id: 'MXN',
  name: 'MX$'
}, {
  id: 'MYR',
  name: 'RM'
}, {
  id: 'MZN',
  name: 'MTn'
}, {
  id: 'NAD',
  name: '$'
}, {
  id: 'NGN',
  name: '₦'
}, {
  id: 'NIO',
  name: 'C$'
}, {
  id: 'NOK',
  name: 'kr'
}, {
  id: 'NPR',
  name: 'Rs.'
}, {
  id: 'NZD',
  name: 'NZ$'
}, {
  id: 'OMR',
  name: 'ر.ع.'
}, {
  id: 'PAB',
  name: 'B/.'
}, {
  id: 'PEN',
  name: 'S/'
}, {
  id: 'PGK',
  name: 'K'
}, {
  id: 'PHP',
  name: '₱'
}, {
  id: 'PKR',
  name: '₨'
}, {
  id: 'PLN',
  name: 'zł'
}, {
  id: 'PYG',
  name: '₲'
}, {
  id: 'QAR',
  name: 'ر.ق'
}, {
  id: 'RON',
  name: 'Lei'
}, {
  id: 'RSD',
  name: 'дин.'
}, {
  id: 'RUB',
  name: '₽'
}, {
  id: 'RWF',
  name: 'FRw'
}, {
  id: 'SAR',
  name: 'ر.س'
}, {
  id: 'SBD',
  name: '$'
}, {
  id: 'SCR',
  name: '₨'
}, {
  id: 'SDG',
  name: '£'
}, {
  id: 'SEK',
  name: 'kr'
}, {
  id: 'SGD',
  name: '$'
}, {
  id: 'SHP',
  name: '£'
}, {
  id: 'SLE',
  name: 'Le'
}, {
  id: 'SOS',
  name: 'Sh'
}, {
  id: 'SRD',
  name: '$'
}, {
  id: 'SSP',
  name: '£'
}, {
  id: 'STN',
  name: 'Db'
}, {
  id: 'SVC',
  name: '₡'
}, {
  id: 'SYP',
  name: '£S'
}, {
  id: 'SZL',
  name: 'E'
}, {
  id: 'THB',
  name: '฿'
}, {
  id: 'TJS',
  name: 'ЅМ'
}, {
  id: 'TMT',
  name: 'm'
}, {
  id: 'TND',
  name: 'د.ت'
}, {
  id: 'TOP',
  name: 'T$'
}, {
  id: 'TRY',
  name: '₺'
}, {
  id: 'TTD',
  name: '$'
}, {
  id: 'TWD',
  name: 'NT$'
}, {
  id: 'TZS',
  name: 'Sh'
}, {
  id: 'UAH',
  name: '₴'
}, {
  id: 'UGX',
  name: 'USh'
}, {
  id: 'USD',
  name: '$'
}, {
  id: 'UYU',
  name: '$U'
}, {
  id: 'UZS',
  name: "so'm"
}, {
  id: 'VES',
  name: 'Bs'
}, {
  id: 'VND',
  name: '₫'
}, {
  id: 'VUV',
  name: 'Vt'
}, {
  id: 'WST',
  name: 'T'
}, {
  id: 'XAF',
  name: 'CFA'
}, {
  id: 'XCD',
  name: 'EC$'
}, {
  id: 'XCG',
  name: 'Cg'
}, {
  id: 'XOF',
  name: 'FCFA'
}, {
  id: 'XPF',
  name: 'CFP'
}, {
  id: 'YER',
  name: '﷼'
}, {
  id: 'ZAR',
  name: 'R'
}, {
  id: 'ZMW',
  name: 'K'
}, {
  id: 'ZWG',
  name: 'ZiG'
}];
export var getCurrencySymbolFromCatalog = function (id) {
  var _a, _b;
  return (_b = (_a = currencyCatalog.find(function (c) {
    return c.id === id;
  })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : id;
};